import { Component, OnInit } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'
import { Persona } from 'se-resource-types/dist/lib/CentralService/Profiles'

const exampleHtml = `
<se-po-parent-contact-info
  [persona]="persona">
</se-po-parent-contact-info>
`

const exampleTypescript = `
import { Component, OnInit } from '@angular/core'
import { Persona } from 'se-resource-types/dist/lib/CentralService/Profiles'

export class ParentContactInfoExampleComponent implements OnInit {
  public persona: Persona

  public ngOnInit(): void {
    this.persona = {
      first_name: 'Natalie',
      last_name: 'Fisher',
      gender: 'female',
      date_of_birth: '1989-12-21',
      email_addresses: [{ address: 'nat.fisher@gmail.com' }],
      phone_numbers: [{ number: '1234567890' }]
    } as Persona
  }
}
`

const template = `<se-fe-docs-example [example]="this">${ exampleHtml }</se-fe-docs-example>`

@Component({
  selector: 'se-po-parent-contact-info-example',
  template,
  styleUrls: ['./parent-contact-info-docs.component.scss'],
  standalone: false,
})
export class ParentContactInfoExampleComponent extends SeFeDocsExampleComponent implements OnInit {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]
  public persona: Persona


  public ngOnInit(): void {
    this.persona = {
      first_name: 'Natalie',
      last_name: 'Fisher',
      gender: 'female',
      date_of_birth: '1989-12-21',
      email_addresses: [{ address: 'nat.fisher@gmail.com' }],
      // eslint-disable-next-line id-blacklist
      phone_numbers: [{ number: '1234567890' }]
    } as Persona
  }

}
